'use client';

import React, { useState } from 'react';
import Link from 'next/link';

export default function ContactPage() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <main style={{ fontFamily: "'DM Sans', 'Roboto', sans-serif", minHeight: '100vh', background: '#f8fafc' }}>
      {/* Navbar */}
      <nav style={{ backgroundColor: '#fff', padding: '16px 0', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img src="/assets/images/image-1778102925137.png" alt="HP Logo" width={91} height={61} style={{ objectFit: 'contain' }} />
          </Link>
          <Link href="/" style={{ color: 'rgb(49,107,156)', textDecoration: 'none', fontSize: '15px', fontWeight: 600 }}>← Back to Store</Link>
        </div>
      </nav>

      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #003366 0%, #0d5fa3 100%)', padding: '48px 40px', textAlign: 'center' }}>
        <h1 style={{ color: '#fff', fontSize: '36px', fontWeight: 800, margin: '0 0 12px' }}>Contact Us</h1>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', margin: 0 }}>We typically respond within 1–2 business days</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '48px 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: '32px', alignItems: 'start' }}>

          {/* Left: Contact Info */}
          <div>
            <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)', marginBottom: '20px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#003366', marginBottom: '24px' }}>Get in Touch</h2>

              {[
                { icon: '📧', label: 'Email Support', value: 'support@barbprinterstore.online', href: 'mailto:support@barbprinterstore.online' },
                { icon: '🔄', label: 'Returns & Refunds', value: 'returns@barbprinterstore.online', href: 'mailto:returns@barbprinterstore.online' },
                { icon: '⚖️', label: 'Legal & Privacy', value: 'legal@barbprinterstore.online', href: 'mailto:legal@barbprinterstore.online' },
              ].map((item) => (
                <div key={item.label} style={{ display: 'flex', gap: '14px', alignItems: 'flex-start', marginBottom: '20px' }}>
                  <div style={{ width: '44px', height: '44px', background: '#eff6ff', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
                    {item.icon}
                  </div>
                  <div>
                    <p style={{ fontSize: '12px', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px' }}>{item.label}</p>
                    <a href={item.href} style={{ color: 'rgb(49,107,156)', fontSize: '14px', fontWeight: 600, textDecoration: 'none' }}>{item.value}</a>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ background: '#fff', borderRadius: '16px', padding: '24px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
              <h3 style={{ fontSize: '16px', fontWeight: 700, color: '#003366', marginBottom: '12px' }}>Business Hours</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {[
                  { day: 'Monday – Friday', hours: '9:00 AM – 6:00 PM EST' },
                  { day: 'Saturday', hours: '10:00 AM – 4:00 PM EST' },
                  { day: 'Sunday', hours: 'Closed' },
                ].map((row) => (
                  <div key={row.day} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                    <span style={{ color: '#64748b' }}>{row.day}</span>
                    <span style={{ color: '#0f172a', fontWeight: 600 }}>{row.hours}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div style={{ background: '#fff', borderRadius: '16px', padding: '36px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
            {submitted ? (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <div style={{ width: '64px', height: '64px', background: '#dcfce7', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '28px' }}>✓</div>
                <h3 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '12px' }}>Message Sent!</h3>
                <p style={{ color: '#64748b', fontSize: '15px', lineHeight: 1.7 }}>
                  Thank you for reaching out. Our team will get back to you within 1–2 business days.
                </p>
                <button
                  onClick={() => { setSubmitted(false); setFormData({ name: '', email: '', subject: '', message: '' }); }}
                  style={{ marginTop: '24px', background: 'rgb(49,107,156)', color: '#fff', border: 'none', padding: '12px 28px', borderRadius: '8px', fontWeight: 700, fontSize: '15px', cursor: 'pointer' }}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <>
                <h2 style={{ fontSize: '20px', fontWeight: 700, color: '#003366', marginBottom: '24px' }}>Send a Message</h2>
                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                    <div>
                      <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Full Name *</label>
                      <input
                        type="text"
                        required
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        placeholder="John Smith"
                        style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Email Address *</label>
                      <input
                        type="email"
                        required
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        placeholder="john@example.com"
                        style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
                      />
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Subject *</label>
                    <select
                      required
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                      style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit', background: '#fff', color: formData.subject ? '#0f172a' : '#94a3b8' }}
                    >
                      <option value="">Select a subject</option>
                      <option value="order">Order Inquiry</option>
                      <option value="return">Return / Refund</option>
                      <option value="technical">Technical Support</option>
                      <option value="billing">Billing Question</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Message *</label>
                    <textarea
                      required
                      rows={5}
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      placeholder="Describe your question or issue in detail..."
                      style={{ width: '100%', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '14px', outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }}
                    />
                  </div>
                  <button
                    type="submit"
                    style={{ background: 'rgb(49,107,156)', color: '#fff', border: 'none', padding: '14px 0', borderRadius: '10px', fontWeight: 700, fontSize: '16px', cursor: 'pointer', fontFamily: 'inherit' }}
                  >
                    Send Message
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#1e293b', padding: '32px 40px', marginTop: '40px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
          <span style={{ color: '#94a3b8', fontSize: '14px' }}>© 2026 Barb Printer Store. All Rights Reserved.</span>
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <Link href="/privacy-policy" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</Link>
            <Link href="/terms-and-condition" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</Link>
            <Link href="/refund-policy" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Refund Policy</Link>
            <Link href="/contact-us" style={{ color: '#7dd3fc', textDecoration: 'none', fontSize: '14px' }}>Contact</Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
